<template>
  <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
  <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
  <UpdateSetting msg="智慧管理小助手"></UpdateSetting>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
import UpdateSetting from './components/UpdateSetting.vue';

export default {
  name: 'App',
  components: {
    UpdateSetting
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
